<template>
  <div class="">
    <form @submit.stop.prevent="onSubmit">

      <form-group :validations="$v.form.name">
        <div slot-scope="{ errors, invalid }">
          <label class="text-right float-right">عنوان آیتم</label>
          <b-form-input type="text" class="m-1" v-model="form.name" placeholder="عنوان آیتم"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
      <form-group :validations="$v.form.url">
        <div slot-scope="{ errors, invalid }">
          <label class="text-right float-right">آدرس اینترنتی</label>
          <b-form-input class="m-1 text-left" v-model="form.url" placeholder="آدرس اینترنتی"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.form.order">
        <div slot-scope="{ errors, invalid }">
          <label class="text-right float-right">ترتیب</label>
          <b-form-input type="text" class="m-1" v-model="form.order" placeholder="ترتیب"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group class="col text-right Font" :validations="$v.form.preview">
        <div slot-scope="{ errors, invalid }">
          <label class="text-right float-right">عکس</label>

          <input id="brand-image" type="hidden" @change="onFileChange"/>

          <div id="preview" class="my-2 text-center">
            <img alt="" v-if="form.preview" class="icon_class" :src="form.preview"/>
          </div>

          <b-form-file
              browse-text="انتخاب عکس"
              @change="onFileChange"
              class="text-center"
              v-model="form.image"
              placeholder="انتخاب عکس"
              drop-placeholder="انتخاب عکس"
          ></b-form-file>

          <div class="my-1 btn btn-danger" v-if="item.icon_class != null" @click="removeIcon()">حذف عکس</div>


          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <div class="my-2">
        <label class="text-right float-right">زیرمجموعه</label>
        <b-form-select class="" v-model="form.parent_id" :options="makeParentOptions"/>
      </div>

      <div class="my-2">
        <label class="text-right float-right">دسترسی</label>
        <select class="custom-select" v-model="form.access">
          <option v-for="(item,index) in menuAccessTranslation" :value="index">{{ item }}</option>
        </select>
      </div>

      <div class="text-center my-3">
        <button type="submit" class="btn btn-primary rounded-pill px-5 ">ثبت</button>
      </div>


    </form>
  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required, url, numeric} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import {flatMenu} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Menu";
import {menuAccessTranslation} from './MenuItemAccessTranslation'

export default {
  name: "MenuItemForm",
  components: {FormErrorsManager, FormGroup},
  props: {
    item: {
      default: () => {
        return {}
      }
    },
    mode: {
      default: 'create' // options: create_sub_item , create(root) , update
    }
  },
  data() {
    return {
      menuAccessTranslation,
      form: {
        menu_id: this.$route.params.id,
        parent_id: null,
        name: '',
        url: '',
        target: '',
        icon_class: null,
        color: '#000',
        status: 1,
        order: 1,
        access: 0,
      }
    }
  },
  computed: {
    makeParentOptions() {
      let items = flatMenu(this.$store.getters["Menu/getMenuItems"])
      let options = [{text: "هیچکدام", value: null}]
      for (let i in items) {
        options.push({text: items[i].name, value: parseInt(items[i].id)})
      }
      return options
    },
  },
  methods: {
    flatMenu,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.icon_class = file;
      this.form.preview = URL.createObjectURL(file);
    },
    removeIcon() {
      if (confirm('آیا از حذف عکس اطمینان دارد؟')) {
        this.$store.dispatch("Menu/deleteItemIcon", this.form).then((res) => {
          this.form.preview = null
          this.form.icon_class = null
        })
      }
    },
    onSubmit() {
      if (this.invalid()) {
        if (this.mode === 'update') {
          this.$store.dispatch("Menu/updateItem", this.form)
        }
        if (['create', 'create_sub_item'].indexOf(this.mode) > -1) {
          this.$store.dispatch("Menu/createItem", this.form)
        }
      }
    },
    initFormData() {
      if (this.mode === 'update') {
        this.form = {...this.form, ...this.item}
        this.form.preview = this.item.icon_class
        this.form.icon_class = null
      }
      if (this.mode === 'create_sub_item') {
        this.form.parent_id = this.item.id
      }
    }
  },
  validations: {
    form: {
      name: {required},
      url: {required,},
      order: {required, numeric},
      preview: {}
    }
  },
  mounted() {
    this.initFormData()
  }
}
</script>

<style scoped>
.icon_class {
  width: 150px;
  height: 150px;
  object-fit: cover;
  margin: auto;
}
</style>